const RenderTableDataInPDF = (tableData, fieldName) => {
  if (tableData[fieldName].length > 0) {
    const data = tableData[fieldName];
    const headers = Object.keys(data[0]);
    const values = data.map((row) => Object.values(row));

    return {
      dataType: "table", // ✅ Add this
      fieldName,
      headers,
      values,
    };
  }
};
export default RenderTableDataInPDF;
